import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeUnmount, onMounted, watch } from "vue";
import { useStore } from 'vuex'
import { debounce } from "lodash";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

watch(store.state, () => {
  store.state.theme === 'dark'
    ? document.body.classList.add('dark-theme')
    : document.body.classList.remove('dark-theme')
})

store.state.theme === 'dark'
  ? document.body.classList.add('dark-theme')
  : document.body.classList.remove('dark-theme')

const debouncedWatch = debounce(() => {
  store.commit('setResizing', false);
}, 500);

const resizeHandler = () => {
  store.commit('setResizing', true);
  debouncedWatch();
}

onMounted(() => {
  window.addEventListener('resize', resizeHandler);
})

onBeforeUnmount(() => {
  debouncedWatch.cancel();
  window.removeEventListener('resize', resizeHandler);
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})